import { defineFrontendModule } from '~/lib/module';

defineFrontendModule({
  name: 'common',
  owner: 'cella',
  scope: ['frontend'],
  description: 'Common UI components and utilities shared across the application.',
});
